import React, { useEffect } from 'react';
import { useSubjects } from './SubjectContext';

const XpBreakdown: React.FC = () => {
  const { payload, visible, hidden, refresh } = useSubjects();
  // XP changes on every answer, so the copy loaded at sign-in goes stale.
  useEffect(() => {
    refresh().catch(() => undefined);
  }, [refresh]);
  if (!payload) return null;
  const subjects = [...visible, ...hidden];
  const total = payload.total_xp;
  return (
    <div className="mb-8 rounded-lg bg-white p-6 shadow dark:bg-gray-800" data-testid="xp-breakdown">
      <div className="mb-4 flex items-baseline justify-between">
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">XP by subject</h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Total <span className="text-xl font-bold text-gray-900 dark:text-white">{total} XP</span>
        </p>
      </div>
      <ul className="space-y-3">
        {subjects.map((subject) => {
          const xp = subject.enrolment.progress.xp;
          const share = total > 0 ? Math.round((xp / total) * 100) : 0;
          return (
            <li key={subject.id}>
              <div className="mb-1 flex justify-between text-sm">
                <span className="font-medium" style={{ color: subject.colour }}>
                  {subject.name}
                  {subject.enrolment.hidden ? ' (hidden)' : ''}
                </span>
                <span className="text-gray-700 dark:text-gray-300">{xp} XP</span>
              </div>
              <div className="h-2 rounded-full bg-gray-200 dark:bg-gray-700">
                <div className="h-2 rounded-full" style={{ width: `${share}%`, backgroundColor: subject.colour }} />
              </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default XpBreakdown;
